const VIDEO_EXTENSIONS = ['.mp4', '.webm', '.mov'];
const IMAGE_EXTENSIONS = ['.png', '.jpg', '.jpeg', '.webp', '.gif'];

export type MediaKind = 'video' | 'image';

function getMediaPath(url: string): string {
  return url.split(/[?#]/, 1)[0].toLowerCase();
}

function hasExtension(url: string, extensions: string[]): boolean {
  const path = getMediaPath(url);
  return extensions.some((extension) => path.endsWith(extension));
}

export function getMediaKind(url: string | null | undefined): MediaKind {
  return url && hasExtension(url, VIDEO_EXTENSIONS) ? 'video' : 'image';
}

export function isImageUrl(url: string): boolean {
  return hasExtension(url, IMAGE_EXTENSIONS);
}

export function isAnimatedImageUrl(url: string): boolean {
  return getMediaPath(url).endsWith('.gif');
}
